module.exports = __webpack_public_path__ + "static/img/gaozhonghuaxue5.e2097f63.jpg";